import {AutoDeliveryDcxActiveInfoBox} from '@/views/AutoDeliveryDcx/AutoDeliveryDcxActive/AutoDeliveryDcxActiveInfoBox';

import AutoDeliveryDcxDetailsDesktop from '../components/AutoDeliveryDcxDetailsDesktop';
import useAutoDeliveryDcxDetails from '../hooks/useAutoDeliveryDcxDetails';
import RescheduleDesktopEndColumn from './RescheduleDesktopEndColumn';
import {RescheduleConfirmationPopup, RescheduleErrorPopup, RescheduleSuccessPopup} from './ReschedulePopup/components';
import {useRescheduleFlow} from './ReschedulePopup/RescheduleFlowContext';
import {RESCHEDULE_STEPS} from './ReschedulePopup/reschedulePopupSteps';
import StatusActiveRescheduleButton from './StatusActiveRescheduleButton';
import StatusActiveSkipButton from './StatusActiveSkipButton';

const StatusActiveDesktop = () => {
    const details = useAutoDeliveryDcxDetails();
    const {
        autoDelivery: {isFreezed},
    } = details;

    const {isOpen, step, handleClose} = useRescheduleFlow();

    const isInlineStep =
        isOpen &&
        (step === RESCHEDULE_STEPS.FREQUENCY ||
            step === RESCHEDULE_STEPS.CALENDAR ||
            step === RESCHEDULE_STEPS.CONFIRMATION);

    return (
        <>
            <AutoDeliveryDcxDetailsDesktop
                status='active'
                extraSection={<AutoDeliveryDcxActiveInfoBox className='mt-4 bg-romance' details={details} />}
                showNextDeliveryHero
                footerActions={
                    !isFreezed && !isInlineStep ? (
                        <>
                            <StatusActiveRescheduleButton className='mt-0 w-full' />
                            <StatusActiveSkipButton className='mt-0 w-full border-2 border-primary-dark-85' />
                        </>
                    ) : undefined
                }
                renderEndColumn={({defaultEndBody, defaultFooter}) => (
                    <RescheduleDesktopEndColumn defaultEndBody={defaultEndBody} defaultFooter={defaultFooter} />
                )}
            />
            {isOpen && step === RESCHEDULE_STEPS.CONFIRMATION && <RescheduleConfirmationPopup />}
            {isOpen && step === RESCHEDULE_STEPS.SUCCESS && <RescheduleSuccessPopup onClose={handleClose} />}
            {isOpen && step === RESCHEDULE_STEPS.ERROR && <RescheduleErrorPopup onClose={handleClose} />}
        </>
    );
};

export default StatusActiveDesktop;
